module.exports = __webpack_public_path__ + "img/gigwicat4.1b0c9d40.jpg";